import React, { Component } from "react";
import { FormGroup, Row, Col, Container, Input } from "reactstrap";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import { getAllCategories, getProductData } from "../Api";
import NavbarTop from "./NavbarTop";
import Footer from "./Footer";
import { countries } from "../Utils/countries";

export default class Resources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statesList: [],
      selectedState: "",
      selectedCity: "",
      selectedCategory: "",
      categoryList: [],
      product: [],
      column: [],
      renderTable: false,
      noCategoryData: "",
    };
  }

  componentDidMount = () => {
    getAllCategories().then((_data) => this.setCategoryData(_data));
    countries.forEach((item) => {
      if (item.name === "India") {
        const states = this.getAllStates(item);
        this.setState({
          statesList: states,
        });
      }
    });
  };

  setCategoryData = (data) => {
    let networkData = data.data;
    if (networkData.categories) {
      if (networkData.categories.length !== 0) {
        let tempArr = [];
        networkData.categories.map((_data) => {
          tempArr.push({
            label: _data.name,
            value: _data.id,
          });
        });
        this.setState({
          categoryList: tempArr,
        });
      }
    }
  };

  getAllStates = (data) => {
    const states = [];
    data.states.forEach((item) => {
      states.push({ value: item.name, label: item.name });
    });
    return states;
  };

  handleSelectedCity = (event) => {
    this.setState({
      selectedCity: event.target.value
    })
  }

  handleStateChange = (selected) => {
    this.setState({
      selectedState: selected.value,
    }, this.generateTable);
  };

  handleCategoryChange = (selected) => {
    this.setState({
      selectedCategory: selected.label,
    }, this.generateTable);
  };

  generateTable() {
    getProductData(this.state.selectedCity, this.state.selectedState, this.state.selectedCategory).then(
      (response)=> {
        var temp_array =[];
        var temp_column = [];
        if(response.data.emergency_contacts.length !== 0){
          const temp_obj = response.data.emergency_contacts[0].details;
          temp_column.push(temp_obj[0])
          var col_keys = Object.keys(temp_column[0])
          var col_obj_arr = [];
          col_keys.map((index)=> {
            var col_obj = {
              dataField: index,
              text: index,
            }
            col_obj_arr.push(col_obj)
          })
          temp_obj.forEach(function (arrayItem) {
            for (const key in arrayItem) {
              let obj_value = arrayItem[key];
                if (obj_value === '' || obj_value === null) {
                  arrayItem[key] = 'N/A'
                } 
            }
            temp_array.push(arrayItem)
          })
          this.setState({
            product: temp_array,
            column: col_obj_arr,
          }, () => {
            this.setState({
              renderTable: true
            })
          });
        }
        else{
          this.setState({
            noCategoryData: "No Data Available"
          })
        }
      })
  }
    
render() {
  return (
    <>
      <NavbarTop />
      <div className="page-header" style={{ backgroundImage: "url(" + require("assets/img/sections/gerrit-vermeulen.jpg").default + ")", minHeight: "40vh",}}>
        <div className="" />
        <div className="content-center">
          <Container>
            <h1>Resources</h1>
            <h5>Search with City, State or Type</h5>
          </Container>
        </div>
      </div>
      <div className="main">
        <div className="section">
          <Container style={{ height: "100vh" }}>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>Enter City</label>
                  <Input
                    defaultValue=""
                    placeholder="Delhi,Mumbai..."
                    type="text"
                    onChange={this.handleSelectedCity}
                  />
                </FormGroup>
              </Col>
              <Col md="1">
                <div className="content-center">
                  <Container>
                    <p style={{ marginTop: "10px" }}>Or</p>
                  </Container>
                </div>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>Enter State</label>
                  <Select
                    className="react-select react-select-default"
                    classNamePrefix="react-select"
                    name="defaultSelect"
                    placeholder="Please Select"
                    options={this.state.statesList}
                    onChange={this.handleStateChange}
                  />
                </FormGroup>
              </Col>
              <Col md="1">
                <div className="content-center">
                  <Container>
                    <p style={{ marginTop: "10px" }}>Or</p>
                  </Container>
                </div>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>Select Category</label>
                  <Select
                    className="react-select react-select-default"
                    classNamePrefix="react-select"
                    name="defaultSelect"
                    placeholder="Please Select"
                    options={this.state.categoryList}
                    onChange={this.handleCategoryChange}
                  />
                </FormGroup>
              </Col>
              {this.state.selectedCategory !== "" && this.state.noCategoryData === "" ? (
                <>
                  <Col md="12" className="text-center">
                    <h3>{this.state.selectedCategory}</h3>
                  </Col>
                  <Col lg="12" className="mt-4">
                    {this.state.renderTable ?
                    <BootstrapTable
                      keyField="id"
                      data={this.state.product}
                      columns={this.state.column}
                      tableLayout='auto'
                      rowStyle={ { width: '100%' } }
                    /> : "" }
                  </Col>
                </>
              ) : (
                <>
                  <h3>{this.state.noCategoryData}</h3>
                </>
              )}
            </Row>
          </Container>
        </div>
      </div>
      <Footer />
    </>
  );
}
}
